/**
 * Page de connexion : écran split-screen (image industrielle + Google OAuth).
 */
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { LOGIN } from "@/constants/testIds";

export default function Login() {
  const { login } = useAuth();

  return (
    <div className="flex min-h-screen">
      <div
        className="relative hidden flex-col justify-between bg-cover bg-center p-12 text-white md:flex md:w-1/2"
        style={{
          backgroundImage:
            "linear-gradient(180deg, rgba(11,83,148,0.78), rgba(11,83,148,0.94)), url('https://images.pexels.com/photos/18845250/pexels-photo-18845250.jpeg')",
        }}
      >
        <div className="flex items-center gap-3">
          <div className="flex h-16 w-24 items-center justify-center rounded-md bg-white p-2 shadow-sm">
            <img src="/lafarge-full.png" alt="Lafarge - A member of Holcim" className="h-full w-full object-contain" />
          </div>
          <span className="text-lg font-bold">Lafarge Ciments France</span>
        </div>
        <div>
          <h2 className="mb-3 text-3xl font-bold leading-tight">Dashboard Sécurité Direction</h2>
          <p className="max-w-md text-white/80">
            La plateforme centrale de pilotage Santé & Sécurité, alimentée en temps réel
            par l'ensemble des sites industriels Lafarge Ciments France.
          </p>
        </div>
        <p className="text-xs text-white/50">© {new Date().getFullYear()} Lafarge Ciments France — Usage interne</p>
      </div>

      <div className="flex w-full flex-col items-center justify-center bg-white p-8 md:w-1/2">
        <div className="w-full max-w-sm">
          <div className="mb-8 flex items-center gap-3 md:hidden">
            <img src="/lafarge-mark.png" alt="Lafarge" className="h-8 w-auto object-contain" />
            <span className="text-base font-bold text-slate-800">Dashboard Sécurité Direction</span>
          </div>
          <h1 className="mb-2 text-2xl font-bold text-slate-800">Connexion</h1>
          <p className="mb-8 text-sm text-slate-500">
            Accédez au dashboard de pilotage HSE avec votre compte Google professionnel.
          </p>
          <Button
            data-testid={LOGIN.googleButton}
            onClick={login}
            className="h-11 w-full gap-2 bg-[#0B5394] transition-colors duration-200 hover:bg-[#094277]"
          >
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12.24 10.285V14.4h6.806c-.275 1.765-2.056 5.174-6.806 5.174-4.095 0-7.439-3.389-7.439-7.574s3.345-7.574 7.439-7.574c2.33 0 3.891.989 4.785 1.849l3.254-3.138C18.189 1.186 15.479 0 12.24 0c-6.635 0-12 5.365-12 12s5.365 12 12 12c6.926 0 11.52-4.869 11.52-11.726 0-.788-.085-1.39-.189-1.989H12.24z" />
            </svg>
            Se connecter avec Google
          </Button>
          <p className="mt-6 text-center text-xs text-slate-400">
            Accès réservé aux collaborateurs Lafarge Ciments France.
          </p>
        </div>
      </div>
    </div>
  );
}
